import React from 'react';

type Crumb = { label: string; onClick?: () => void };

export const Breadcrumbs: React.FC<{ items: Crumb[] }> = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb" className="mb-2 text-xs text-gray-500">
      <ol className="flex flex-wrap items-center gap-0.5">
        {items.map((c, idx) => (
          <li key={idx} className="flex items-center">
            {idx > 0 && <span className="mx-1.5 text-gray-300">/</span>}
            {c.onClick ? (
              <button onClick={c.onClick} className="hover:text-teal-600 hover:underline transition-colors">{c.label}</button>
            ) : (
              <span className="text-gray-600">{c.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};


